import React from 'react'

const Filter = () => {
    return (
        <div className="sondaria-filter-container">
            <p className="sondaria-filter-header">FILTRES</p>
            <p className="sondaria-filter-title">Catégories</p>
            <div className="sondaria-filter-bubbles">
                <div className="filter-bubble">Dilemme</div>
                <div className="filter-bubble">Business</div>
                <div className="filter-bubble">Personnel</div>
                <div className="filter-bubble">Autre</div>
            </div>
            <p className="sondaria-filter-title">Taille</p>
            <div className="sondaria-filter-bubbles">
                <div className="filter-bubble">Court</div>
                <div className="filter-bubble">Moyen</div>
                <div className="filter-bubble">Long</div>
            </div>
            <p className="sondaria-filter-title">Type</p>
            <div className="sondaria-filter-bubbles">
                <div className="filter-bubble">Durée limitée</div>
                <div className="filter-bubble">Terminé</div>
                <div className="filter-bubble">Déjà répondu</div>
                <div className="filter-bubble">Exclusif</div>

            </div>
            <p className="sondaria-filter-title">Autre</p>
            <div className="sondaria-filter-bubbles">
                <div className="filter-bubble">Publié par un ami</div>
                <div className="filter-bubble">Sponsorisé</div>

            </div>
        </div>
    )
}

export default Filter
